<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<blockquote>
<blockquote>
<p class="para"><a id="page_7"></a>Now the day is over,<br/>Night is drawing nigh;<br/>Shadows of the evening<br/>Steal across the sky.</p>
<p class="para">      —<span class="smallcaps">SABINE BARING-GOULD</span></p>
</blockquote>
</blockquote>
<p class="linespace"> </p>
<blockquote>
<blockquote>
<p class="para">History . . . is indeed little more than<br/>the register of the crimes, follies, and<br/>misfortunes of mankind.</p>
<p class="para">         —<span class="smallcaps">EDWARD GIBBON</span></p>
</blockquote>
</blockquote>
<p class="linespace"> </p>
<blockquote>
<blockquote>
<p class="para">It ain’t necessarily so.</p>
<p class="para">         —<span class="smallcaps">IRA GERSHWIN</span></p>
</blockquote>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?3c51e6a5